export const DEFAULT_ENV = {
  production: false,
  apiBase: '/api/v0',
  chainID: 0,
};
